import React from 'react'
import { useSelector } from 'react-redux'
import BrandPrimaryLogo from 'src/components/BrandPrimaryLogo/BrandPrimaryLogo'
import HowToJoin from 'src/components/HowToJoin/HowToJoin'
import UnauthedPageContainer from 'src/components/UnauthedPageContainer/UnauthedPageContainer'
import { SupportedBrands } from 'src/enums'
import { selectBrandName } from 'src/redux/selectors/session.selectors'

import { imageStyle } from './HowToJoin.style'

interface HowToJoinPageProps {
  setShowHowToJoin: (val: boolean) => void
}

const HowToJoinPage: React.FC<HowToJoinPageProps> = (props) => {
  const brandName = useSelector(selectBrandName)

  return (
    <UnauthedPageContainer
      topLeftImage={
        <>
          {brandName !== SupportedBrands.Bmo && (
            <div css={imageStyle}>
              <BrandPrimaryLogo />
            </div>
          )}
        </>
      }
    >
      <HowToJoin setShowHowToJoin={props.setShowHowToJoin} />
    </UnauthedPageContainer>
  )
}

export default HowToJoinPage
